<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import PeopleCard from '@/components/PeopleCard.vue';

import shenfen from '@/assets/law/shenfen.jpg';
import songlei from '@/assets/law/songlei.jpg';
import weijiangong from '@/assets/law/weijiangong.jpg';
import xumeiling from '@/assets/law/xumeiling.jpg';
import zhouminghui from '@/assets/law/zhouminghui.jpg';

const { t } = useI18n();

const openPeople = [
  {
    photo: zhouminghui,
    title: t('law.translate.pepele1.title'),
    name: t('law.translate.pepele1.name'),
  },
  {
    photo: weijiangong,
    title: t('law.translate.pepele2.title'),
    name: t('law.translate.pepele2.name'),
  },
  {
    photo: shenfen,
    title: t('law.translate.pepele3.title'),
    name: t('law.translate.pepele3.name'),
  },
  {
    photo: songlei,
    title: t('law.translate.pepele4.title'),
    name: t('law.translate.pepele4.name'),
  },
  {
    photo: xumeiling,
    title: t('law.translate.pepele5.title'),
    name: t('law.translate.pepele5.name'),
  },
]
</script>

<template>
  <div class="markdown-expert-review-group my-32px">
    <ul class="m-0 flex flex-wrap p-0 <2xl:flex-nowrap <md:overflow-x-auto">
      <li v-for="item in openPeople" :key="item.name" class="h-160px w-223px list-none not-last-of-type:mr-44px <md:flex-shrink-0 <2xl:not-last-of-type:mr-8px">
        <PeopleCard :name="item.name" :photo="item.photo" :position="item.title" />
      </li>
    </ul>
  </div>
</template>
